import type { CanvasBoardAnimation } from "#/game/animation/types";
import { getExplosionFrame } from "#/game/fxSprites";

import { getCannonDeathDrawEffect, type UnitDeathDrawEffect } from "./boardAnimations";
import { TILE_SIZE } from "./boardConstants";
import type { UnitDrawLayout } from "./boardUnitGeometry";

export function drawDeathExplosion({
  ctx,
  layout,
  deathEffect,
}: {
  ctx: CanvasRenderingContext2D;
  layout: UnitDrawLayout;
  deathEffect: UnitDeathDrawEffect;
}): void {
  drawDeathExplosionAt({
    ctx,
    drawX: layout.drawX,
    drawY: layout.drawY,
    deathEffect,
  });
}

function drawDeathExplosionAt({
  ctx,
  drawX,
  drawY,
  deathEffect,
}: {
  ctx: CanvasRenderingContext2D;
  drawX: number;
  drawY: number;
  deathEffect: UnitDeathDrawEffect;
}): void {
  if (!deathEffect.explosionKind) return;
  const frame = getExplosionFrame({
    kind: deathEffect.explosionKind,
    frame: deathEffect.explosionFrame,
  });
  if (!frame) return;
  const drawW = Math.min(frame.sw, TILE_SIZE);
  const drawH = Math.min(frame.sh, TILE_SIZE);
  const x = drawX + (TILE_SIZE - drawW) / 2;
  const y = drawY + (TILE_SIZE - drawH) / 2;
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(frame.img, frame.sx, frame.sy, frame.sw, frame.sh, x, y, drawW, drawH);
}

export function drawGhostCannonExplosions({
  ctx,
  animation,
  nowMs,
}: {
  ctx: CanvasRenderingContext2D;
  animation: CanvasBoardAnimation | null;
  nowMs: number;
}): void {
  const ghosts =
    animation?.type === "move" || animation?.type === "attackFx"
      ? (animation.ghostCannons ?? [])
      : [];
  for (const ghost of ghosts) {
    const deathEffect = getCannonDeathDrawEffect({
      pos: ghost.pos,
      animation,
      nowMs,
    });
    if (!deathEffect || deathEffect.showUnit || !deathEffect.explosionKind) continue;
    drawDeathExplosionAt({
      ctx,
      drawX: ghost.pos.x * TILE_SIZE,
      drawY: ghost.pos.y * TILE_SIZE,
      deathEffect,
    });
  }
}
